import {
  FINANCIAL_DETAIL_FETCH,
  FINANCIAL_DETAIL_FETCH_FAILURE,
  FINANCIAL_DETAIL_FETCH_SUCCESS,
  FINANCIAL_DETAIL_RESET,
  FINANCIAL_DETAIL_SET,
} from "../actionTypes";

const INITIAL_STATE = {
  operator_id: null,
  operator_sales: {},
  operator_sales_kpis: {},
  operator_sales_grade: 0,
  loading: false,
  error: null,
};

export default function FinancialDetailReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FINANCIAL_DETAIL_FETCH:
      return { ...state, loading: true, error: null };
    case FINANCIAL_DETAIL_FETCH_SUCCESS: {
      const { operator_sales, operator_sales_kpis, operator_sales_grade, operator_id } =
        action.payload;
      return {
        ...state,
        operator_sales,
        operator_sales_kpis,
        operator_sales_grade,
        operator_id,
        loading: false,
        error: null,
      };
    }
    case FINANCIAL_DETAIL_FETCH_FAILURE: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        error: payload,
      };
    }
    case FINANCIAL_DETAIL_SET: {
      const { payload } = action;
      return { ...state, operators: payload };
    }
    case FINANCIAL_DETAIL_RESET: {
      return { ...INITIAL_STATE, operator_sales: {}, operator_sales_kpis: {} };
    }
    default:
      return state;
  }
}
